var I18n, Optimize, config;

window._ = require('underscore');

window.md5 = require('../../../src/frontend/vendor/md5');

window.Cookie = require('../../../src/frontend/vendor/cookie');

window.Hogan = require('hogan.js');

require('../groupon_modules/modernizr-hacks');

I18n = require('../../../node_modules/grapefruit/lib/I18n');

window.I18n = new I18n();

require('optimize-suite');

require('../../../src/frontend/vendor/eventPause-custom');

require('jquery.finger');

window.CartWidget = require('../../../modules/cart_widget/frontend/cart_widget');

window.Fingerprint = require('fingerprintjs');

Optimize = window.Optimize;

config = Optimize.suiteData.config;

config.finch = {
  config: Optimize.finchConfig
};

Optimize.config = config;

OptimizeSuite.init(config);

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvY29yZS9mcm9udGVuZC9jb21tb24vY29yZV9saWJyYXJpZXMuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvY29yZS9mcm9udGVuZC9jb21tb24vY29yZV9saWJyYXJpZXMuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsTUFBTSxDQUFDLENBQVAsR0FBVyxPQUFBLENBQVEsWUFBUjs7QUFDWCxNQUFNLENBQUMsR0FBUCxHQUFrQixPQUFBLENBQVEsa0NBQVI7O0FBQ2xCLE1BQU0sQ0FBQyxNQUFQLEdBQWtCLE9BQUEsQ0FBUSxxQ0FBUjs7QUFDbEIsTUFBTSxDQUFDLEtBQVAsR0FBZSxPQUFBLENBQVEsVUFBUjs7QUFDZixPQUFBLENBQVEsb0NBQVI7O0FBQ0EsSUFBQSxHQUFPLE9BQUEsQ0FBUSwyQ0FBUjs7QUFDUCxNQUFNLENBQUMsSUFBUCxHQUFrQixJQUFBLElBQUEsQ0FBQTs7QUFDbEIsT0FBQSxDQUFRLGdCQUFSOztBQUVBLE9BQUEsQ0FBUSxnREFBUjs7QUFDQSxPQUFBLENBQVEsZUFBUjs7QUFDQSxNQUFNLENBQUMsVUFBUCxHQUFvQixPQUFBLENBQVEsbURBQVI7O0FBQ3BCLE1BQU0sQ0FBQyxXQUFQLEdBQXFCLE9BQUEsQ0FBUSxlQUFSOztBQUVwQixXQUFZOztBQUNaLFNBQVUsUUFBUSxDQUFDOztBQUNwQixNQUFNLENBQUMsS0FBUCxHQUFlO0VBQUEsTUFBQSxFQUFRLFFBQVEsQ0FBQyxXQUFqQjs7O0FBQ2YsUUFBUSxDQUFDLE1BQVQsR0FBa0I7O0FBQ2xCLGFBQWEsQ0FBQyxJQUFkLENBQW1CLE1BQW5CIn0=
